"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkInvite = exports.isInvite = void 0;
const InviteItem_1 = require("./InviteItem");
function isInvite(object) {
    return checkInvite(object).fulfilled;
}
exports.isInvite = isInvite;
function checkInvite(object) {
    const result = { fulfilled: true, reasons: [] };
    if (typeof object !== "object") {
        result.fulfilled = false;
        result.reasons.push({ path: "$", value: object, explanation: "not an object" });
        return result;
    }
    Object.values(object).forEach((subObject) => {
        const itemResult = (0, InviteItem_1.checkInviteItem)(subObject);
        if (!itemResult.fulfilled && itemResult.reasons) {
            result.fulfilled = false;
            result.reasons.concat(itemResult.reasons);
        }
    });
    return result;
}
exports.checkInvite = checkInvite;
//# sourceMappingURL=Invite.js.map